import { CheckoutSessionCriteria, OrderCriteria } from '@nemuru-eng/js-api-client';

import { Font } from '@/components/shared/components/Font';
import { Text } from '@/components/shared/components/Text';
import { ApplicationType } from '@/config/types';

export const orderMerchantReferenceFieldColumn = ({
  flex,
  applicationType = ApplicationType.ORDER,
}: {
  flex?: number;
  applicationType?: ApplicationType;
}) => {
  const referenceValueByApplicationType = (row: OrderCriteria | CheckoutSessionCriteria) => {
    switch (applicationType) {
      case ApplicationType.ORDER:
      case ApplicationType.PAY_BY_LINK:
        if ('order' in row)
          return {
            field: 'order_merchant_ref_1_value',
            reference1: row.order.orderMerchantReference1,
            reference2: row.order.orderMerchantReference2,
          };
        break;
      case ApplicationType.CHECKOUT_SESSION:
        if ('cart' in row)
          return {
            field: 'checkout_session_merchant_ref_1_value',
            reference1: row.cart.merchantOrderReference1,
            reference2: row.cart.merchantOrderReference2,
          };
        break;
    }
  };

  const fieldNameByApplicationType = (applicationType: ApplicationType) => {
    switch (applicationType) {
      case ApplicationType.ORDER:
        return 'order_merchant_ref_1_value';
      case ApplicationType.CHECKOUT_SESSION:
        return 'checkout_session_merchant_ref_1_value';
    }
  };

  return {
    flex: flex ?? 0.45,
    field: fieldNameByApplicationType(applicationType),
    align: 'left',
    disableOnRowClick: true,
    headerName: <Text tId={'ORDER_REFERENCE_LABEL'} />,
    renderCell: (rowData: { row: OrderCriteria }) => (
      <>
        <div
          style={{
            display: 'flex',
            alignItems: 'right',
            justifyContent: 'flex-end',
            flexDirection: 'column',
            lineHeight: 1.43,
            maxWidth: '100%',
          }}
        >
          <div className="shorted-cell simple-select overflow-text-ellipsis">
            {referenceValueByApplicationType(rowData.row)?.reference1}
          </div>
          {referenceValueByApplicationType(rowData.row)?.reference2 && (
            <Font variant={'caption'}>
              (<Text tId={'#2'} />: {referenceValueByApplicationType(rowData.row)?.reference2 ?? '-'})
            </Font>
          )}
        </div>
      </>
    ),
  };
};
